import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
export function getClient() {
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      uri: process.env.NEXT_PUBLIC_API_ENDPOINT,
    }),
  })
}